var map = {
	"./popover.css": "./libs/embed-react/src/components/css/popover.css",
	"./popup.css": "./libs/embed-react/src/components/css/popup.css",
	"./sidetab.css": "./libs/embed-react/src/components/css/sidetab.css",
	"./slider.css": "./libs/embed-react/src/components/css/slider.css",
	"./widget.css": "./libs/embed-react/src/components/css/widget.css"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./libs/embed-react/src/components/css sync recursive ^\\.\\/.*\\.css$";